import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChalkboardTeacher, faBuilding, faGavel, faCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Іконка реєстру — на плитці вибору («Реєстри», Catalogs.jsx).
 */
const CATALOG_ICONS = {
  dancers: faUser,
  coaches: faChalkboardTeacher,
  clubs: faBuilding,
  judges: faGavel,
};

export default function CatalogIcon({ catalog, size }) {
  return <FontAwesomeIcon icon={CATALOG_ICONS[catalog] || faCircle} style={size ? { fontSize: size } : undefined} />;
}
